<template>
  <div class="company-tianyancha">
    <gkFormText
      ref="formText"
      :field="field"
      :rule="rules"
      :customRule="{ cusCompanyTianyancha: customRule.cusCompanyTianyancha }"
      :placeholder="data.tips"
      type="text"
      :validity="true"
      :length="100"
      :value="inputValue"
      @input="handleInput"
      :trigger="['change']"
      size="normal"
      color="gray"
    >
    </gkFormText>
    <div class="options-dropdown" v-show="showOptions">
      <div class='cover' @click="handleBlur"></div>
      <ul class="country-dropdown">
        <li v-for='(item, i) in companyList' :key='i' :class="{active: item.name == inputValue}" @click="selectCompany(item)">
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import gkFormText from 'gkui/form/FormText'
import AccountService from '@/service/account.service'

export default {
  name: 'company-tianyancha',
  props: {
    data: VueTypes.object.def({}),
    value: VueTypes.string.def('')
  },
  data () {
    return {
      inputValue: '',
      companyList: [],
      showOptions: false,
      isSelect: false,
      needGetCompanyList: false,
      form: null
    }
  },
  inject: ['getFormRef'],
  components: {
    gkFormText
  },
  mounted () {
    this.form = this.getFormRef()
  },
  methods: {
    selectCompany (item) {
      this.inputValue = item.name
      this.showOptions = false
      this.needGetCompanyList = false
      this.isSelect = true
    },

    handleInput (val) {
      this.inputValue = val
      this.needGetCompanyList = true
      this.isSelect = false
    },

    handleBlur () {
      this.showOptions = false

      if (!this.isSelect) {
        this.inputValue = ''
        this.form.validate(this.field)
      }
    }
  },
  computed: {
    options () {
      return this.data.details.options[0]
    },
    field () {
      return `${this.data.id}-${this.options.key}-${this.data.type}`
    },
    rules () {
      const rule = []
      if ((this.data.is_must_answer && !this.inputValue) || this.needGetCompanyList) {
        rule.push({
          cusCompanyTianyancha: '请输入企业名称进行检索，选择正确的企业名称'
        })
      }
      return rule
    },
    customRule () {
      return {
        cusCompanyTianyancha () {
          return {
            valid: false
          }
        }
      }
    }
  },
  watch: {
    value (val) {
      this.inputValue = val
    },
    inputValue (val) {
      if (val && this.needGetCompanyList) {
        AccountService.getCompanyTianyancha(val).then(res => {
          this.companyList = res.list
          this.showOptions = true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/_common";

.company-tianyancha {
  position: relative;
}

.cover{
  position: fixed; z-index: 10; top: 0; left: 0; right: 0; bottom: 0;
  background-color: transparent;
}
.options-dropdown {
  & .country-dropdown {
    box-sizing: border-box;
    position: absolute; z-index: 10; left: 0; top: 48px;
    padding: 10px 0;
    width: 100%; max-height: 200px;
    overflow-y: auto;
    background: #ffffff;
    border: 1px solid $grayForm; border-radius: 4px;
    box-shadow: 6px 10px 16px rgba(0, 0, 0, 0.2);
    & li {
      display: flex;
      justify-content: space-between;
      padding: 0 50px 0 10px;
      @include font(16, 400);
      color: $bodyBlack; line-height: 40px;
      cursor: pointer;
      @extend %transition;

      &:hover,
      &.active {
        position: relative;
        background: $blueHoverNew;
        color: #fff;
        &::after {
          content: '';
          position: absolute;
          right: 20px; top: 18px;
          width: 11px; height: 6px;
          border-left: 2px solid #fff;
          border-bottom: 2px solid #fff;
          transform: translateY(-50%) rotate(-45deg);
        }
      }
    }

    @include mobile {
      position: fixed;
      top: 50%; left: 50% !important;
      width: 85vw; max-height: 60vh;
      transform: translate(-50%, -50%);
      & li {
        font-size: 14px;
      }
    }
  }
}
</style>
